import { KatButton } from '@amzn/katal-react';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { CreateCaseConstants } from 'src/constants/ProjectConstants';
import {
  CREATE_CASE_PAGE_ROUTE,
  LIST_CASE_PAGE_ROUTE,
} from 'src/constants/UrlConstants';
import { Breadcrumb } from 'src/components/Breadcrumb';
import { emitClickMetrics, MetricsName } from 'src/metrics';
import { IGetCaseListItem } from 'src/state/slice/models/CaseLifecycleTypes';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import { CaseListGrid } from './CaseListGrid';

export const CaseListContainer = styled.div`
  margin: 1em;
`;

export const CreateCaseNavigation = styled.div`
  float: right;
`;

export interface CaseListPageProps {
  data: Array<IGetCaseListItem>;
}

const CaseListPage: React.FC<CaseListPageProps> = ({ data }) => {
  let navigate = useNavigate();
  const { createCaseBundle } = useContext(TranslationContext);

  const createCaseClickHandler = () => {
    emitClickMetrics(MetricsName.LIST_CASE_PAGE, 'CreateCase.Button.Clicked');
    navigate(CREATE_CASE_PAGE_ROUTE);
  };

  return (
    <div data-testid="case_list_page_testid">
      <Breadcrumb page={LIST_CASE_PAGE_ROUTE}></Breadcrumb>
      <CaseListContainer>
        <CreateCaseNavigation>
          <KatButton
            data-testid="create_case_button_testid"
            label={createCaseBundle.getMessage(
              CreateCaseConstants.CREATE_CASE_HEADER,
            )}
            size="base"
            variant="primary"
            onClick={createCaseClickHandler}
          ></KatButton>
        </CreateCaseNavigation>
        <CaseListGrid data={data} />
      </CaseListContainer>
    </div>
  );
};

export default CaseListPage;
